import Layout from "../../layout/main";
import CustomerOrganization from "../../components/customerOrganization";
/**
 * CustomerOrganizationPage
 *
 * صفحه مدیریت سازمان مشتری که اطلاعات مربوط به سازمان مشتری را نمایش می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای ساختار و استایل کلی اپلیکیشن
 * - نمایش کامپوننت CustomerOrganization که اطلاعات سازمان مشتری را ارائه می‌دهد
 *
 * @returns JSX.Element
 */

const CustomerOrganizationPage = () => {
  return (
    <Layout>
      <CustomerOrganization />
    </Layout>
  );
};

export default CustomerOrganizationPage;
